const C = {
  name: "Toggle",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5 8C19.8807 8 21 6.88071 21 5.5C21 4.11929 19.8807 3 18.5 3C17.1193 3 16 4.11929 16 5.5C16 6.88071 17.1193 8 18.5 8Z" fill="currentColor"/>
<path d="M5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11H18.5C21.5376 11 24 8.53757 24 5.5C24 2.46243 21.5376 0 18.5 0H5.5ZM2 5.5C2 3.567 3.567 2 5.5 2H18.5C20.433 2 22 3.567 22 5.5C22 7.433 20.433 9 18.5 9H5.5C3.567 9 2 7.433 2 5.5Z" fill="currentColor"/>
<path d="M8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11929 16 5.5 16C6.88071 16 8 17.1193 8 18.5Z" fill="currentColor"/>
<path d="M5.5 13C2.46243 13 0 15.4624 0 18.5C0 21.5376 2.46243 24 5.5 24H18.5C21.5376 24 24 21.5376 24 18.5C24 15.4624 21.5376 13 18.5 13H5.5ZM2 18.5C2 16.567 3.567 15 5.5 15H18.5C20.433 15 22 16.567 22 18.5C22 20.433 20.433 22 18.5 22H5.5C3.567 22 2 20.433 2 18.5Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Toggle
};
